import { QuickStatsCard } from "@shared/components/QuickStatsCard";
import {
  useCurrency,
  useRemoteUtilityId,
} from "@shared/selectors/globalSelectors";
import { useChequesKpi } from "@features/cx/paymentsv2/hooks";
import {
  Clock,
  CheckCircle2,
  XCircle,
  AlertCircle,
  CalendarClock,
  Layers,
} from "lucide-react";

export function Dashboard() {
  const currency = useCurrency();
  const remoteUtilityId = useRemoteUtilityId();
  const { data: kpiData } = useChequesKpi(Number(remoteUtilityId));
  const result = kpiData?.result || {};

  const quickStatsData = [
    {
      title: "Pending Clearance",
      count: result.pendingClearanceCount || 0,
      trendSummary: `${currency} ${result.pendingClearanceFloat || 0} in float`,
      icon: <Clock className="h-6 w-6 text-orange-500" />,
    },
    {
      title: "Cleared Today",
      count: result.clearedTodayCount || 0,
      trendSummary: `${currency} ${result.clearedTodayAmount || 0}`,
      icon: <CheckCircle2 className="h-6 w-6 text-teal-500" />,
    },
    {
      title: "Dishonoured Today",
      count: result.dishonouredTodayCount || 0,
      trendSummary: `${currency} ${result.dishonouredTodayAmount || 0} reversed`,
      icon: <XCircle className="h-6 w-6 text-red-500" />,
    },
    {
      title: "Penalties Posted",
      count: `${currency} ${result.penaltiesPostedAmount || 0}`,
      trendSummary: `${result.penaltiesDishonouredCount || 0} dishonoured - ${result.penaltiesWaivedCount || 0} waived`,
      icon: <AlertCircle className="h-6 w-6 text-red-500" />,
    },
    {
      title: "Due for Deposit",
      count: result.dueForDepositCount || 0,
      trendSummary: "Checks past deposit deadline",
      icon: <CalendarClock className="h-6 w-6 text-orange-500" />,
    },
    {
      title: "Lots Pending Approval",
      count: result.lotsPendingApprovalCount || 0,
      trendSummary: `Over ${currency} ${result.lotsPendingApprovalThresholdAmount || 0} threshold`,
      icon: <Layers className="h-6 w-6 text-blue-500" />,
    },
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {quickStatsData.map((stat, index) => (
          <QuickStatsCard
            key={index}
            title={stat.title}
            count={stat.count}
            trendSummary={stat.trendSummary}
            icon={stat.icon}
          />
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
